export default __webpack_public_path__ + "static/media/santander.2ad33761.png";